import { getImageSizeString } from '@tunasong/models'
import { isStorageUrlsExpired, type Entity, type ImageSizeType } from '@tunasong/schemas'

/** Get URLs to the image and scaled sizes. We use a Lambda@Edge function to resize images for URLs from storage */
export const useImage = (image?: Entity, size: ImageSizeType = 'large') => {
  /** Signed wildcard URL, we add the dimensions as query parameters. That is handled in a Lambda@Edge function running sharp */

  const isExpired = isStorageUrlsExpired(image?.storageUrls)
  const url = !isExpired ? image?.storageUrls?.url : undefined
  /** Local URLs never reach the resizer: a blob, or a file or data URL from the mobile reader's saved images (#3042) */
  const isLocalUrl = url?.startsWith('blob:') || url?.startsWith('file:') || url?.startsWith('data:')

  if (isLocalUrl) {
    return url
  }
  if (url) {
    return `${url}&d=${getImageSizeString(size)}`
  }

  return undefined
}
